// Core Modules
import { HttpContextToken } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

/**
 * Injection token for the browser Window object.
 * Use this token to inject the Window object in a type-safe manner.
 *
 * @example
 * ```typescript
 * private readonly window = inject(WINDOW);
 * ```
 */
export const WINDOW = new InjectionToken<Window>('Window');

/**
 * Marks a request as a background refresh. The auth interceptor tears the session down when
 * `/auth/me` or `/refresh` fails, which is right while a session is being established and wrong for
 * a periodic refresh — a transient 500 would log out a working session. The flag skips that one
 * force-logout branch and nothing else: a flagged 401/503 still goes through the interceptor's
 * re-authentication handler, and a flagged 403 still redirects to `/unauthorized`.
 *
 * @example
 * ```typescript
 * this.httpClient.get(url, { context: new HttpContext().set(BACKGROUND_REFRESH, true) });
 * ```
 */
export const BACKGROUND_REFRESH = new HttpContextToken<boolean>(() => false);
